import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../lib/api";
import Seo from "../components/Seo";
import { safeHtml } from "../lib/safeHtml";

const PATHS = {
  terms: { slug: "terms", path: "/terms" },
  privacy: { slug: "privacy", path: "/privacy" },
  cookies: { slug: "cookies", path: "/cookies" },
  accessibility: { slug: "accessibility", path: "/accessibility" },
};

export default function Policy({ slug: fixedSlug }) {
  const params = useParams();
  const slug = fixedSlug || params.slug;
  const [doc, setDoc] = useState(null);
  useEffect(() => {
    api.get(`/public/policies/${slug}`).then(r => setDoc(r.data)).catch(() => setDoc({ title: "Not found", html: "<p>Sorry, this page doesn't exist.</p>" }));
  }, [slug]);
  const meta = PATHS[slug] || { path: `/${slug}` };
  if (!doc) return <div className="min-h-[60vh]" />;
  return (
    <article className="max-w-3xl mx-auto px-6 lg:px-10 pt-12 pb-24" data-testid={`policy-${slug}`}>
      <Seo path={meta.path} title={doc.title} description={`${doc.title} — Seasons Art Class East Croydon`} />
      <div className="font-hand text-[#A685BD] text-2xl">legal</div>
      <h1 className="font-display text-4xl md:text-5xl text-[#5D2C8F] mb-2">{doc.title}</h1>
      {doc.last_updated && <div className="text-xs text-[#6E6074] mb-8">Last updated: {doc.last_updated}</div>}
      <div className="prose prose-sm max-w-none text-[#3A2A47] leading-relaxed policy-content" dangerouslySetInnerHTML={safeHtml(doc.html)} />
      <style>{`
        .policy-content h2 { font-family: 'Fraunces', Georgia, serif; color:#5D2C8F; font-size:1.75rem; margin-top:2rem; margin-bottom:0.5rem; }
        .policy-content h3 { font-family: 'Fraunces', Georgia, serif; color:#5D2C8F; font-size:1.3rem; margin-top:1.4rem; margin-bottom:0.4rem; }
        .policy-content p  { margin-top:0.75rem; }
        .policy-content ul { margin-top:0.5rem; padding-left:1.3rem; list-style:disc; }
        .policy-content li { margin-top:0.3rem; }
        .policy-content a  { color:#5D2C8F; text-decoration:underline; }
        .policy-content code { background:#FAF6EE; padding:0 4px; border-radius:4px; font-family: ui-monospace, 'SF Mono', monospace; }
        .policy-content table { margin-top:1rem; }
      `}</style>
    </article>
  );
}
